var render, staticRenderFns
import script from "./search_filter.vue?vue&type=script&lang=js&"
export * from "./search_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260820083957/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb1b158')) {
      api.createRecord('3bb1b158', component.options)
    } else {
      api.reload('3bb1b158', component.options)
    }
    
  }
}
component.options.__file = "app/javascript/app/desktop/filters/search_filter.vue"
export default component.exports